import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { ApiError } from './lib/api';
import { applyTheme, getTheme } from './lib/theme';
import { router } from './router';
import { ToastProvider } from './ui/feedback';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/app.css';

applyTheme(getTheme());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 4xx sind endgültig (fehlende Rechte, nicht gefunden); nur Netz-/Serverfehler erneut versuchen.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
